import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://wochenhighlight.de/getwochenhighlight/30', // Replace with your API base URL
  headers: {
                'Content-Type': 'application/json' // Example header
             },
  withCredentials: true, // Set this if you are using cookies or authentication
});

export default instance;